import React from "react";
import { useFormContext } from "react-hook-form";
import { NumberControl } from "@tiny/components";
import { useStyles } from "../Value.styles";

interface PercentRangeValueProps {
  prefixName: string;
  disabled?: boolean;
}

function PercentRangeValue(props: PercentRangeValueProps) {
  const { prefixName, disabled } = props;
  const { trigger, watch } = useFormContext();
  const classes = useStyles();

  const value = watch(`${prefixName}.value`);

  const nameFrom = `${prefixName}.value.value[0]`;
  const nameTo = `${prefixName}.value.value[1]`;

  const validatePercent = (v?: number) => {
    if (typeof v === "number" && !isNaN(v)) {
      if (hasMoreThanOneDecimal(v)) {
        return "Please enter a number with at most 1 decimal place";
      }
    }
  };

  const hasMoreThanOneDecimal = (value: number) => {
    return !Number.isInteger(value * 10);
  };

  const validateTo = (v: number | string | null) => {
    if (typeof v === "number" && !isNaN(v)) {
      if (value?.value?.[0] > v) {
        return "Lower than from";
      }
      if (hasMoreThanOneDecimal(v)) {
        return "Please enter a number with at most 1 decimal place";
      }
    }
  };

  React.useEffect(() => {
    trigger([nameFrom, nameTo]);
  }, [trigger, nameFrom, nameTo]);

  return (
    <div className={classes.root}>
      <NumberControl
        name={nameFrom}
        className={classes.field}
        placeholder="From %"
        aria-label="Condition from percentage"
        showHelperTextMargin
        required
        disabled={disabled}
        watchValue
        min={0.1}
        max={100}
        validate={validatePercent}
      />
      <NumberControl
        name={nameTo}
        className={classes.field}
        placeholder="To %"
        aria-label="Condition to percentage"
        showHelperTextMargin
        required
        disabled={disabled}
        watchValue
        min={0.1}
        max={100}
        validate={validateTo}
      />
    </div>
  );
}

export default PercentRangeValue;
